<ng-container *ngrxLet="viewModel$; let viewModel;">
  <div class="action-button"
       [matMenuTriggerFor]="datasourceSyncMenu">
    <div class="iconContainer">
      @if (!viewModel?.syncStatusLoading) {
        <mat-icon [class]="viewModel.dataSyncColorAndSvg.colorClass"
                  [svgIcon]="viewModel.dataSyncColorAndSvg.svgIcon"/>
      } @else {
        <mat-spinner [diameter]="24"></mat-spinner>
      }
    </div>
    <div class="label-small"
         [class]="viewModel.dataSyncColorAndSvg.colorClass">Sync
    </div>
  </div>


  <mat-menu #datasourceSyncMenu="matMenu">
    <div class="flex flex-col w-[360px]
                p-6"
         (click)="$event.stopPropagation()">

      <span class="label pb-1">Listing data sync</span>

      <div class="flex flex-col">
        <div class="flex flex-row">
          <mat-icon [class]="viewModel.dataSyncColorAndSvg.colorClass"
                    [svgIcon]="viewModel.dataSyncColorAndSvg.svgIcon"/>
          <span [class]="'pl-2 title ' +
                          viewModel.dataSyncColorAndSvg.colorClass">{{
              viewModel.syncStatus ?
                  (('ADDRESS_LIST.DATASOURCE_SYNC.' + viewModel.syncStatus) | translate) : 'n/a'
            }}</span>
        </div>

        <mat-progress-bar mode="determinate"
                          [value]="viewModel.syncProgressNumber"
                          [class]="'py-1 ' + viewModel.dataSyncProgressBarClass"/>

        <div class="flex flex-row w-full justify-between
                    body-large pb-6">
          <span>{{ viewModel.elapsedTime }}</span>
          <span>{{ viewModel.syncProgressNumber + '% done' }}</span>
        </div>

        <div class="flex flex-row pb-6 gap-x-4">

          <div class="flex flex-col w-1/2">
            <span class="label">Sync start</span>
            <span class="body-large">{{
                viewModel.restartTime ?
                    (viewModel.restartTime | date:'dd.MM.yyyy, HH:mm') : 'n/a'
              }}</span>
          </div>

          <div class="flex flex-col w-1/2">
            <span
                class="label">Last listing sync</span>
            <span class="body-large">{{
                viewModel.updateTime ?
                    (viewModel.updateTime | date:'dd.MM.yyyy, HH:mm') : 'n/a'
              }}</span>
          </div>

        </div>

      </div>

      <div class="flex flex-row justify-between items-center h-[36px] loadDetailsButton">
        <button mat-icon-button
                (click)="getSyncDetails()"
                class="text-neutral-30"
                matTooltip="Refresh"
                [disabled]="viewModel.syncStatusLoading">
          <mat-icon svgIcon="refresh"
                    [ngClass]="{ loading: viewModel.syncStatusLoading }"></mat-icon>
        </button>
        <div matTooltip="{{ restartButton.disabled ?
          'You cannot restart a running/pending datasource sync, or during request processing' :
          'Restart datasource sync' }}"
             class="relative">
          <button #restartButton
                  (click)="restartDataSync()"
                  mat-flat-button
                  [disabled]="viewModel.restartDisabled"
                  color="primary">Restart data sync
            @if (viewModel.restartDatasyncLoading) {
              <mat-progress-bar class="restartButtonLoadingBar"
                                mode="indeterminate"/>
            }
          </button>
        </div>
      </div>

    </div>
  </mat-menu>
</ng-container>


